<script setup lang="ts">
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();

useSeo({
  title: t('bank_account.payer_accounts.title'),
});

// Contas Bancárias é uma tela nova, só do painel V2 — o site antigo nunca
// teve uma página própria pra isso (PayerAccounts.vue vive embutido dentro
// de "Dados da conta"). Sem o flag, redireciona pra lá em vez de mostrar
// tela em branco.
if (!isUserV2Enabled.value) {
  await navigateTo(localeLink('/user/account'), { redirectCode: 302 });
}
</script>

<template>
  <UserV2ScreenBankAccounts v-if="isUserV2Enabled" />
</template>
